import { child, runTransaction } from 'firebase/database'
import { getCustomersDB } from '../fire'
import type { DeliveryStore } from './guidedEmailDelivery'
// Narrow transaction: updateCustomer would also touch sort_key and trigger cascades.
export function guidedEmailStore(
  customerID: string,
  deliveryField:
    | 'contract_signed_email_delivery'
    | 'roof_claiming_signed_email_delivery' = 'contract_signed_email_delivery',
): DeliveryStore {
  if (!customerID || /[.#$[\]/]/.test(customerID))
    throw new Error('Invalid customer ID')
  if (
    ![
      'contract_signed_email_delivery',
      'roof_claiming_signed_email_delivery',
    ].includes(deliveryField)
  )
    throw new Error('Invalid delivery field')
  const field = child(getCustomersDB(), customerID + '/' + deliveryField)
  return {
    async change(update) {
      const r = await runTransaction(field, (raw) => update(raw), {
        applyLocally: false,
      })
      return { committed: r.committed, value: r.snapshot.val() }
    },
  }
}
